import React from 'react'
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Login from '../Components/Login';
import PublicRouters from './PublicRouter';
import PrivateRouters from './PrivateRouter';
import { getCookie } from '../Helpers/Utils';
import Dashboard from '../Components/Dashboard';
import AuthenticateProvider from '../Context/AuthenticateProvider';
import CustomerList from '../Components/Customer/List';
import CreateProduct from '../Components/Products/Add';
import CategoryList from '../Components/Category/Category';
import SubCategoryList from '../Components/Category/SubCategory';
import ProductList from '../Components/Products/List';
import ProductView from '../Components/Products/View';
import Pos from '../Components/Sale/Pos';
import LowStockList from '../Components/LowStacks/List';
import StockHistory from '../Components/Stock/History';
import InventoryAdd from '../Components/Stock/Add';
import EditProduct from '../Components/Products/Update';
import SalesList from '../Components/Sale/List';
import POSEdit from '../Components/Sale/Update';
import PaymentsList from '../Components/Sale/Payments';
import CustomerReport from '../Components/Reports/Customer';
import InventoryReport from '../Components/Reports/Inventory';
import ProfitLossReport from '../Components/Reports/ProfitLoss';
import SalesSummaryReport from '../Components/Reports/Sales';
import TopProductsReport from '../Components/Reports/TopSelling';
import UserProfile from '../Components/Profile';
import SaleReturn from '../Components/Sale/Return';
import CustomerHistory from '../Components/Customer/History';
import ReturnSales from '../Components/Sale/ReturnList';
import QuotationList from '../Components/Quotation/List';
import Quotation from '../Components/Quotation/Create';

const index = () => {
  return (
    <React.Fragment>
      <AuthenticateProvider>
        <Router>
          <Routes>
            <Route element={<PublicRouters />}>
              <Route path="/login" element={<Login />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Route>
            <Route element={<PrivateRouters />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/pos" element={<Pos />} />
              <Route path="/profile" element={<UserProfile />} />
              <Route path="/pos-edit/:id/:payid" element={<POSEdit />} />
              <Route path="/pos-pay/:id" element={<POSEdit />} />
              <Route path="/pos-list" element={<SalesList />} />
              <Route path="/customers" element={<CustomerList />} />
              <Route path="/customer-history/:customer_id" element={<CustomerHistory />} />
              <Route path="/category" element={<CategoryList />} />
              <Route path="/subcategory" element={<SubCategoryList />} />
              <Route path="/quotation" element={<QuotationList />} />
              <Route path="/quotation-create" element={<Quotation />} />
              <Route path="/products-edit/:id" element={<EditProduct />} />
              <Route path="/products" element={<ProductList />} />
              <Route path="/products-add" element={<CreateProduct />} />
              <Route path="/payments" element={<PaymentsList />} />
              <Route path="/lowstock" element={<LowStockList />} />
              <Route path="/customer-report" element={<CustomerReport />} />
              <Route path="/inventory-report" element={<InventoryReport />} />
              <Route path="/profitloss-report" element={<ProfitLossReport />} />
              <Route path="/sales-report" element={<SalesSummaryReport />} />
              <Route path="/return-list" element={<ReturnSales />} />
              <Route path="/top-products-report" element={<TopProductsReport />} />
              <Route path="/history" element={<StockHistory />} />
              <Route path="/inventory-add" element={<InventoryAdd />} />
              <Route path="/sales-return" element={<SaleReturn />} />
              <Route path="/products-view/:id" element={<ProductView />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </Router>
      </AuthenticateProvider>
    </React.Fragment>
  )
}

export default index
